import { Cookie } from 'ng2-cookies';
import { inject, Injectable } from '@angular/core';
import { SiteCookies } from '@chefami-monorepo/types';
import { ENV_CONFIG } from '../tokens';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly env = inject(ENV_CONFIG);

  setItem(key: string, value: unknown, useSession = false): void {
    const storage = useSession ? sessionStorage : localStorage;
    storage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string, useSession = false): T | null {
    const storage = useSession ? sessionStorage : localStorage;
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string, useSession = false): void {
    const storage = useSession ? sessionStorage : localStorage;
    storage.removeItem(key);
  }

  clear(useSession = false): void {
    const storage = useSession ? sessionStorage : localStorage;
    storage.clear();
  }

  hasItem(key: string, useSession = false): boolean {
    const storage = useSession ? sessionStorage : localStorage;
    return storage.getItem(key) !== null;
  }

  setCookie(key: SiteCookies, value: string) {
    const days = 7;
    const expires = days ? new Date(Date.now() + days * 86_400_000) : undefined;
    Cookie.set(key, value, expires, '/', this.env.cookieDomain, true);
  }

  getCookie(name: SiteCookies) {
    return Cookie.get(name);
  }

  deleteCookie(name: SiteCookies) {
    Cookie.delete(name, '/', this.env.cookieDomain);
  }

  deleteTokens() {
    this.deleteCookie(SiteCookies.ACCESS_TOKEN);
    this.deleteCookie(SiteCookies.REFRESH_TOKEN);
  }
}
